import {gql, useQuery} from '@apollo/client';
import {SelectOption} from '../components/AutoForm/AutoFieldNew';
import {GetStaffIdOfUser} from '../schema-types/GetStaffIdOfUser';
import {ListStaff, ListStaffVariables} from '../schema-types/ListStaff';
import {getStaffIdQuery} from './useGetStaffId';

export const useListStaff = (staffType?: 'adviser' | 'paraplanner') => {
  const {data: currentUserData} = useQuery<GetStaffIdOfUser>(getStaffIdQuery);
  const {data, loading} = useQuery<ListStaff, ListStaffVariables>(
    gql`
      query ListStaff($staffType: String) {
        staff(staffType: $staffType) {
          id
          curoId
          name
        }
      }
    `,
    {
      variables: {
        staffType,
      },
    }
  );

  const staffSelectOptions: SelectOption[] =
    data?.staff
      ?.map((x) => ({
        label: x.name!,
        value: x.id,
      }))
      .sort((a, b) => {
        if (a.label > b.label) {
          return 1;
        }
        return -1;
      }) || [];

  return {
    staff: data?.staff,
    staffSelectOptions,
    staffLoading: loading,
    loggedInUser: currentUserData?.getCurrentUser,
  };
};
